'use client'
import Link from 'next/link'
import { useState } from 'react'
import { usePathname } from 'next/navigation'
import { useUIStore } from '@/store'
import { createNewPage } from '@/utils/createUrl'
import { Logo } from './Logo'
import { Button } from './ui/Button'
import { useQuery } from '@tanstack/react-query'
//import { fetchData } from '@/lib/apiService'

export const TopMenu = ({ menuItems }: any) => {
  const pathname = usePathname()
  const isHome = pathname === '/'

  const openSideMenu = useUIStore((state) => state.openSideMenu)

  const setObjSearch = (item: any, subItem: any) => {
    let dataSearch = {
      category: item.name,
      categoryId: item.id,
      brand: subItem.name,
      brandId: subItem.id,
    }

    return createNewPage(dataSearch)
  }

  const [showSubMenu, setShowSubMenu] = useState<string | null>(null)

  return (
    <>
      <div className="bg-custom-blue h-[15px]"></div>
      <nav className="px-5 pb-3 pt-3 flex justify-between items-center w-full bg-white shadow-xl">
        {/* Center Menu */}
        {!isHome && (
          <Link href="/">
            <Logo src={`/logoNeumaticos.webp`} />
          </Link>
        )}

        <div className="flex-1 flex justify-center space-bwtween">
          <div className="hidden sm:flex relative mt-4">
            {menuItems &&
              menuItems.map((item: any) => (
                <div
                  key={item.id}
                  onMouseEnter={() => setShowSubMenu(item.name)}
                  className="m-2 p-2 rounded-md transition-all hover:bg-custom-red hover:text-white cursor-pointer relative"
                >
                  <div className="whitespace-nowrap">{item.name}</div>
                  {showSubMenu === item.name && (
                    <div
                      onMouseLeave={() => setShowSubMenu(null)}
                      className="absolute w-[400px] flex-col left-1/2 top-full mt-6 p-4 bg-white rounded-md flex min-h-[3rem]transform -translate-x-1/2 shadow-lg z-[2]"
                    >
                      {item.brands.map((submenu: any) => (
                        <Link
                          rel="canonical"
                          key={submenu.name}
                          className="px-2 hover:bg-custom-blue hover:text-white text-black whitespace-nowrap"
                          href={setObjSearch(item, submenu)} //"/neumaticos/autos"
                        >
                          {submenu.name}
                        </Link>
                      ))}
                      <div
                        style={{ minHeight: '0.1rem' }}
                        className="mt-[1rem] bg-red-800 shadow-lg"
                      ></div>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>

        <div className="right-5 mt-[15px]">
          <Button
            onClick={openSideMenu}
            className="rounded-md transition-all hover:bg-gray-100"
          >
            Buscar
          </Button>
        </div>
      </nav>
      <div
        style={{ minHeight: '0.15rem' }}
        className="bg-red-800 shadow-lg"
      ></div>
    </>
  )
}
